/* The batches a clash note names: the first two, then how many more --
   a lab booked by twenty batches should not print twenty names. The
   same cap as the API's refusal (batch.service.js labClashRefusal). */
const SHOWN = 2;

export const clashNames = (clashes) => {
  const names = (clashes || []).map((c) => c.name);
  const more = names.length - SHOWN;
  return more > 0 ? `${names.slice(0, SHOWN).join(", ")} and ${more} more` : names.join(", ");
};
